import { DataItemType, FormControlType } from "../../../schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc-address.vue";
import mobile from "./components/mobile-address.vue";
export const info = {
    title: "地址",
    title_i18n: "{\"zh\": \"地址\", \"en\": \"Address\"}",
    type: "inputAddress",
    icon: "h-icon-all-position-o",
    dataItemType: DataItemType.Address,
    formControllerType: FormControlType.Address,
    group: "",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile,
    },
};
